import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'PUBLICATION_UPDATE',
    smsDelete : 'PUBLICATION_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        category: [],
        publication: [],

        submitSuccess: false,
        categoryLoading: false,
        categoryError: false,
        publicationLoading: false,
        publicationError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_CATEGORY(state, results) {
            state.category = results;
        },

        CATEGORY_LOADING (state, loading) {
            state.categoryLoading = loading;
        },

        CATEGORY_ERROR (state, hasError) {
            state.categoryError = hasError;
        },

        SET_PUBLICATION(state, results) {
            state.publication = results;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        PUBLICATION_LOADING (state, loading) {
            state.publicationLoading = loading;
        },

        PUBLICATION_ERROR (state, hasError) {
            state.publicationError = hasError;
        }
    },

    actions: {
        // Category 
        async addCategory ({commit, dispatch}, payload) {
            commit('CATEGORY_LOADING', true);
            commit('CATEGORY_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.post(V1API.create_publication_category, payload.category, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCategory')
                return response

            } catch (e) {
                commit('CATEGORY_ERROR', true);
            } finally {
                commit('CATEGORY_LOADING', false);
            }
        },

        async fetchCategory ({ commit }) {
            commit('CATEGORY_LOADING', true);
            commit('CATEGORY_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.publication_category_list, config);
                let response = result.data.data
                commit('SET_CATEGORY', response);
                return result
            } catch(error) {
                commit('CATEGORY_ERROR', true);
            } finally {
                commit('CATEGORY_LOADING', false);
            }
        },

        async deleteCategory({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.delete_publication_category + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchCategory')
            return response
        },

        // Publicatio
        async addPublication ({commit, dispatch}, payload) {
            commit('PUBLICATION_LOADING', true);
            commit('PUBLICATION_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token")
                },
                "Content-Type": "multipart/form-data"
            };

            try {
                let data2= new FormData()
                let payloadData = buildFormData(data2, payload.publication);

                let response = await axios.post(V1API.create_publication, payloadData, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchPublication')
                return response

            } catch (e) {
                commit('PUBLICATION_ERROR', true);
            } finally {
                commit('PUBLICATION_LOADING', false);
            }
        },

        async fetchPublication ({ commit }) {
            commit('PUBLICATION_LOADING', true);
            commit('PUBLICATION_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.publication_list, config);
                let response = result.data.data
                commit('SET_PUBLICATION', response);
                return result
            } catch(error) {
                commit('PUBLICATION_ERROR', true);
            } finally {
                commit('PUBLICATION_LOADING', false);
            }
        },

        async updatePublication ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                },
                "Content-Type": "multipart/form-data"
            };

            try {
                let data2= new FormData()
                let payloadData = buildFormData(data2, payload.publication);

                let response = await axios.patch(V1API.update_publication + payload.id, payloadData, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchPublication')
                return response

            } catch (e) {
                commit('PUBLICATION_ERROR', true);
            } finally {
                commit('PUBLICATION_LOADING', false);
            }
        },

        async deletePublication({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.delete_publication + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchPublication')
            return response
        },

        async toggleFeatured ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let response = await axios.get(V1API.toggle_publication_featured + payload.id, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchPublication')
                return response

            } catch (e) {

            } finally {

            }
        },

        async updateSerial ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.get(V1API.update_pub_serial + payload.id + '/' + payload.serial, config).then(result => {
                let items = result.data
                // dispatch('getProjectList')
                return result
            })
            return response
        }
    },

    getters: {}
}
